import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { i18nAssetUrl } from "../../i18n/i18n-asset-url";

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    private translations: any = {};
    private currentLang: string = 'en';
    private languageSubject = new BehaviorSubject<string>('en');

    constructor(private http: HttpClient) {
        this.loadTranslations(this.currentLang);
    }

    setLanguage(lang: string): void {
        if (lang !== this.currentLang) {
            this.currentLang = lang;
            this.loadTranslations(lang);
        }
    }

    getCurrentLanguage(): string {
        return this.currentLang;
    }

    onLanguageChange(): Observable<string> {
        return this.languageSubject.asObservable();
    }

    private loadTranslations(lang: string): void {
        const path = i18nAssetUrl(`assets/i18n/${lang}.json`);
        this.http.get(path).subscribe((translations: any) => {
            this.translations = translations;
            this.languageSubject.next(lang);
        });
    }

    translate(key: string): string {
        return this.getNestedValue(this.translations, key) || key;
    }

    private getNestedValue(obj: any, key: string): string | null {
        if (!obj || !key) {
            return null;
        }
        return key.split('.').reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), obj);
    }
}
